<template>
  <div class="topnav-box">
    <template v-if="isImg">
      <van-image lazy-load width="46" height="30" :src="require('../../assets/images/logo.png')" />
    </template>
    <template v-else>
      <van-icon name="arrow-left" size="0.6rem" color="#ffffff" @click="goBack"/>
    </template>
    <div class="title">{{title}}</div>
  </div>
</template>

<script>
export default {
  name: 'Topnav',
  props: {
    isImg: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '武汉青年创业中心'
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<style lang="scss" scoped>
.topnav-box{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 998;
  width: 100%;
  height: 44px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  background-color: #2eaeb4;
  .title{
    font-weight: bold;
    font-size: 0.4rem;
    color: #ffffff;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    width: 100%;
    line-height: 44px;
    z-index: -1;
  }
}
</style>